export const SITE_URL = 'https://www.myeu.uk'

export const SITE_EMAIL_BODY =
  'Have a look at all of the local projects the EU has funded' +
  ` at ${SITE_URL} — you can enter your postcode and see what's` +
  ' happening near you.'

export const SITE_DESCRIPTION =
  'The EU invests around £5 billion a year in the UK. Search by your address' +
  ' or postcode to see some of the investments near you.'
